import Box from 'ui/src/components/Box'
import LanguageSelector from 'ui/src/components/LanguageSelector'

interface LanguageSelectorContainerProps {
  handleLanguageChange(language: string): Promise<void>
}

const LanguageSelectorContainer = ({ handleLanguageChange }: LanguageSelectorContainerProps) => {
  return (
    <Box>
      <LanguageSelector onChange={handleLanguageChange} iconSize="1.25rem" />
    </Box>
  )
}

export default LanguageSelectorContainer
